import produce from 'immer';
import { MOUSEOVER_SECTION, MOUSELEAVE_SECTION, MOUSEOVER_ELEMENT, MOUSELEAVE_ELEMENT, TOGGLE_FILE_MANAGER, START_APP_DRAG, ENDED_APP_DRAG, SCROLL_CONTAINER, MOUSEOVER_COMMENTABLE_AREA, MOUSELEAVE_COMMENTABLE_AREA } from 'EmailEditorUI/redux/actions/LayoutBuilderActionTypes';
import { DROP_ELEMENT_ON_SECTION, DROP_ELEMENT_ON_PLACEHOLDER, DROP_ELEMENT_ON_ELEMENT, SELECT_BUILTIN_WIDGET, CLICK_CATCHER_CLICKED, SELECT_ELEMENT, SELECT_SECTION } from 'EmailEditorUI/redux/actions/IframeSyncedActionTypes';
export const initialState = {
  mouseOverElementId: null,
  mouseOverSectionId: null,
  mouseOverCommentableAreaId: null,
  isFileManagerOpen: false,
  isDraggingWithinApp: false,
  draggedItemType: null,
  scrollContainerBoundaries: null
};
const userInterfaceReducer = (state = initialState, action) => {
  return produce(state, draft => {
    switch (action.type) {
      case MOUSEOVER_SECTION:
        draft.mouseOverSectionId = action.id;
        return draft;
      case MOUSEOVER_COMMENTABLE_AREA:
        draft.mouseOverCommentableAreaId = action.id;
        return draft;
      case MOUSELEAVE_COMMENTABLE_AREA:
        draft.mouseOverCommentableAreaId = null;
        return draft;
      case SELECT_SECTION:
      case MOUSELEAVE_SECTION:
        draft.mouseOverSectionId = null;
        return draft;
      case MOUSEOVER_ELEMENT:
        draft.mouseOverElementId = action.id;
        return draft;
      case MOUSELEAVE_ELEMENT:
      case DROP_ELEMENT_ON_SECTION:
      case DROP_ELEMENT_ON_PLACEHOLDER:
      case DROP_ELEMENT_ON_ELEMENT:
      case SELECT_BUILTIN_WIDGET:
      case SELECT_ELEMENT:
        draft.mouseOverElementId = null;
        draft.mouseOverCommentableAreaId = null;
        return draft;
      case CLICK_CATCHER_CLICKED:
        draft.mouseOverElementId = null;
        draft.mouseOverSectionId = null;
        draft.mouseOverCommentableAreaId = null;
        return draft;
      case TOGGLE_FILE_MANAGER:
        draft.isFileManagerOpen = action.isOpen;
        return draft;
      case START_APP_DRAG:
        draft.isDraggingWithinApp = true;
        draft.draggedItemType = action.draggedItemType;
        return draft;
      case ENDED_APP_DRAG:
        draft.isDraggingWithinApp = false;
        draft.draggedItemType = null;
        return draft;
      case SCROLL_CONTAINER:
        draft.scrollContainerBoundaries = action.boundaries;
        return draft;
      default:
        return draft;
    }
  });
};
export default userInterfaceReducer;